import React, { useMemo } from "react";
import { InventoriesActions } from "./InventoriesActions";

export const useColumnsStationDigital = (inventoryType, keyInventory, edited) => {
  const columns = useMemo(() => {
    const cols = [
      {
        Header: "Unidad",
        accessor: "number",
        filterable: true,
        filterMethod: (filter, row) =>
          row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Volumen Total",
        accessor: "totalVolume",
        Cell: ({ original }) => <div>{original.totalVolume} lts</div>,
        filterable: true,
        filterMethod: (filter, row) =>
          row.totalVolume?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Volumen Actual",
        accessor: "currentVolume",
        Cell: ({ original }) => <div>{original.currentVolume} lts</div>,
        filterable: true,
        filterMethod: (filter, row) =>
          row.currentVolume?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Porcentaje Digital",
        accessor: "currentPercentage",
        filterable: true,
        filterMethod: (filter, row) =>
          row.currentPercentage?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Total kilos",
        accessor: "totalKg",
        Cell: ({ original }) => (
          <div>
            {original.totalKg !== undefined && original.totalKg > 0
              ? original.totalKg.toFixed(2)
              : 0}{" "}
            kg
          </div>
        ),
        filterable: true,
        filterMethod: (filter, row) =>
          row.totalKg?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Fecha sync",
        accessor: "syncDate",
        filterable: true,
        filterMethod: (filter, row) =>
          row.syncDate?.toString()?.toLowerCase().includes(filter.value.toLowerCase()),
      },
      {
        Header: "Acciones",
        Cell: ({ original }) => (
          <InventoriesActions
            original={original}
            inventoryType={inventoryType}
            keyInventory={keyInventory}
            edited={edited}
          />
        ),
      },
    ];

    return cols;
  }, [inventoryType, keyInventory, edited]);

  return columns;
};
